import PromoteBTG from "@features/banner/PromoteBTG/PromoteBTG";
import { useCountry } from "@hooks/useCountry";

/**
 * The controller for the PromoteBTG component.
 * Decides whether to show the component based on the country.
 */
const PromoteBTGController = (): React.ReactElement => {
  const { isSGUser } = useCountry();

  if (isSGUser) return <></>;

  return <PromoteBTG className="mb-6" />;
};

export default PromoteBTGController;
